import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { defaultTechDataParentTabColNames } from "configs/techDataTableSpecs";

import { getSelectedColumnsThunk } from "./techDataThunk";

export const getSelectedColumns = createAsyncThunk("techData/getSelectedColumns", getSelectedColumnsThunk);

const initialState = {
  activeTab: "",
  childFiles: [],
  childIsLoading: true,
  colNames: defaultTechDataParentTabColNames,
  columnsIsLoading: false,
  parentFiles: [],
  parentIsLoading: true,
};

const techDataSlice = createSlice({
  extraReducers: (builder) => {
    builder
      .addCase(getSelectedColumns.pending, (state) => {
        state.columnsIsLoading = true;
      })
      .addCase(getSelectedColumns.fulfilled, (state, { payload }) => {
        if (payload?.length > 0) state.colNames = payload[0];
        state.columnsIsLoading = false;
      })
      .addCase(getSelectedColumns.rejected, (state) => {
        state.columnsIsLoading = false;
      });
  },
  initialState,
  name: "techData",
  reducers: {
    setSelectedColumns: (state, { payload }) => {
      state.colNames = { ...state.colNames, ...payload };
    },
  },
});

export const { setSelectedColumns } = techDataSlice.actions;
export default techDataSlice.reducer;
